import { render } from "./DesktopBarAvatarMenuContext.vue?vue&type=template&id=4e0ce622&scoped=true"
import script from "./DesktopBarAvatarMenuContext.vue?vue&type=script&lang=js"
export * from "./DesktopBarAvatarMenuContext.vue?vue&type=script&lang=js"

import "./DesktopBarAvatarMenuContext.vue?vue&type=style&index=0&id=4e0ce622&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0ce622"]])

export default __exports__